<template>
  <v-main>
    <v-footer padless color="grey darken-4">
    <v-col
      class="text-center white--text"
      cols="12"
    >
      {{ new Date().getFullYear() }} — <strong> Powered By Fábio Cardoso</strong>
    </v-col>
  </v-footer>
  </v-main>
</template>

<script>
  export default {
    name: 'rodape',
    data: () => ({
    }),
    methods: {
     
    },
    mounted() {
      
    },
    computed: {
        
    },
    created() {
      
    }

  }
</script>

<style scoped>

</style>